import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "ifl_auth_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({
  baseURL: API_BASE,
  timeout: 120000,
});

// Attach Authorization header on every request
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  return config;
});

// Bounce to /login on 401
let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearToken();
      if (onUnauthorized) onUnauthorized();
    }
    return Promise.reject(err);
  }
);

export default api;

export const fmtBRL = (n) => {
  const num = Number(n) || 0;
  return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};
export const fmtBRLSmart = (n) => {
  const num = Number(n) || 0;
  if (num !== 0 && Math.abs(num) < 0.01) {
    return num.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 4,
      maximumFractionDigits: 4,
    });
  }
  return fmtBRL(num);
};
export const fmtInt = (n) => (Number(n) || 0).toLocaleString("pt-BR");
export const fmtNum = (n, digits = 2) =>
  (Number(n) || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
export const fmtPct = (n) => `${fmtNum(n, 1)}%`;
